import { SelfContainedCommand, CommandExecutionContext } from '../../../../types/commands';
import { StandardToolResult, createSuccessResult, createErrorResult } from '../../../../types/standardToolResults';
import { API_BASE_URL } from '../../../../api/config';
import fetchService from '../../../../services/fetchService';
import { createFileLogger } from '../../../../utils/logger';

const log = createFileLogger('CONTACTS_COMMANDS');

export const contactsDiscoverCommand: SelfContainedCommand = {
  id: 'contacts_discover',
  description: '🔎 DISCOVER: Auto-discover new contacts from Gmail threads and Calendar events. Creates stub Contact entities for people you communicate with but haven\'t logged yet.',
  autonomyLevel: 'confirm',
  visualTreatment: 'demonstrative',

  schema: {
    parameters: [],
  },

  examples: {
    good: [
      {
        input: {},
        expectedOutput: createSuccessResult('Discovered 5 new contacts', { discovered: 5, enriched: 0 }),
        description: 'Auto-discover contacts from Gmail and Calendar',
      },
    ],
    bad: [],
  },

  handler: async (
    params: Record<string, never>,
    context: CommandExecutionContext
  ): Promise<StandardToolResult> => {
    try {
      context.onProgress?.({
        progress: 'Scanning Gmail threads for new contacts...',
        discovered: 0,
      });

      const result = await fetchService(`${API_BASE_URL}/contacts-app/discover`, {
        method: 'POST',
      });

      const discovered = result?.discovered ?? 0;

      context.onProgress?.({
        progress: `Found ${discovered} new contact${discovered !== 1 ? 's' : ''}`,
        discovered,
      });

      log.info('[contacts_discover] Discovered', discovered, 'contacts');
      return createSuccessResult(
        discovered > 0
          ? `Discovered ${discovered} new contact${discovered !== 1 ? 's' : ''}`
          : 'No new contacts found — your contacts are up to date',
        { discovered, enriched: result?.enriched ?? 0 }
      );
    } catch (error) {
      log.error('[contacts_discover] Failed', error);
      return createErrorResult(
        'Failed to discover contacts',
        error instanceof Error ? error.message : 'Unknown error',
        'execution'
      );
    }
  },
};
